import { Plus } from "lucide-react";
import { USE_CASES } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";
import { Icon } from "@/components/shared/Icon";

const spans = ["lg:col-span-3", "lg:col-span-3", "lg:col-span-2", "lg:col-span-2", "lg:col-span-2"];

export const UseCases = () => (
  <section data-testid="use-cases-section" className="section relative">
    <div className="wrap">
      <SectionHeading
        eyebrow="Technology in the real world"
        title="Solution architectures we design and deploy."
        text="Reference architectures showing how technologies combine into a working operation."
      />
      <Stagger className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-6" stagger={0.07}>
        {USE_CASES.map((u, i) => (
          <Item key={u.title} data-testid={`use-case-${i + 1}`} className={`card group flex min-h-[260px] flex-col p-7 ${spans[i]}`}>
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-line bg-navy text-cyan-400"><Icon name={u.icon} className="h-5 w-5" /></span>
              <span className="eyebrow !text-slate-500">Architecture</span>
            </div>
            <h3 className="mt-8 text-xl font-semibold">{u.title}</h3>
            <div className="mt-auto flex flex-wrap items-center gap-2 pt-8">
              {u.stack.map((s, j) => (
                <span key={s} className="flex items-center gap-2">
                  <span className="rounded-md bg-navy px-3 py-1.5 font-mono text-[11px] text-slate-300 ring-1 ring-line transition-colors group-hover:ring-cyan-400/40">{s}</span>
                  {j < u.stack.length - 1 && <Plus className="h-3 w-3 text-cyan-400" />}
                </span>
              ))}
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
